<template>
  <div class="video-post-index-container">
    <i class="icon-index"></i>
    <div class="button-group">
      <pcw-button type="normal" @click="onAddVideoClick">添加视频</pcw-button>
      <input v-show="false" type="file" ref="input" name="file" :accept="accept" @change="onFilesChange" />
    </div>
    <div class="index-text-container">
      <div class="index-text">点击添加按钮上传视频</div>
      <div class="index-sub-text">
        <span>上传视频,即表示您已经同意</span>
        <span class="link" @click.stop="dialogVisible = true">《上传服务条款》</span>
        <span>，请勿上传色情及反动违法视频。建议使用Chrome浏览器。</span>
      </div>
      <div class="index-sub-text">视频建议为MP4、MKV、MOV格式，文件大小≤1G</div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="45%" :lock-scroll="true" class="pcw-text-panel-dialog">
      <pcwTextPanel
        title="上传服务条款"
        :contents="[
          {
            itemType: 1,
            text:
              '第一条 用户在叭嗒的相关平台上发布时，应当遵守 《中华人民共和国著作权法》及与著作权保护相关的法律和规章，保证不侵犯著作权人的合法利益。 如果您是版权作者或机构，对本产品网友分享上传了您的作品有任何异议，请提供相关作品的版权证明，并立即联系我们删除，叭嗒将在第一时间内回复您，待信息核实后做出相应调整，以示叭嗒对著作版权的公正和维护。',
          },
          {
            itemType: 1,
            text: '第二条 本平台用户拥有发布信息的权利，但不得发布含有以下内容的信息：',
          },
          {
            itemType: 1,
            text: '(一) 反对宪法确定的基本原则的；',
          },
          {
            itemType: 1,
            text: '(二) 危害国家统一、主权和领土完整的；',
          },
          {
            itemType: 1,
            text: '(三) 泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；',
          },
          {
            itemType: 1,
            text: '(四) 煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；',
          },
          {
            itemType: 1,
            text: '(五) 破坏国家宗教政策，宣扬邪教、迷信的；',
          },
          {
            itemType: 1,
            text: '(六) 散布谣言，扰乱社会秩序，破坏社会稳定的；',
          },
          {
            itemType: 1,
            text: '(七) 宣扬淫秽、赌博、暴力、色情、凶杀、恐怖或者教唆犯罪的；',
          },
          {
            itemType: 1,
            text: '(八) 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；',
          },
          {
            itemType: 1,
            text: '(九) 有法律、行政法规和国家规定禁止的其他内容的。',
          },
          {
            itemType: 1,
            text: '第三条 用户不得发布含有色情、淫秽及暗示性色情内容的文章图片和视频。',
          },
          {
            itemType: 1,
            text: '第四条 用户不得发布垃圾广告、不应发布不实信息。',
          },
          {
            itemType: 1,
            text: '第五条 用户应尊重他人名誉权，不得以侮辱、诽谤等方式对他人进行人身攻击。',
          },
          {
            itemType: 1,
            text:
              '第六条 用户应尊重他人隐私权，不得侵害他人隐私。隐私包括真实姓名、身份证号、电话号码、家庭住址及用户不愿公开的其他个人信息。涉及公众利益或经由当事人同意的除外。',
          },
          {
            itemType: 1,
            text: '第七条 用户应尊重他人肖像权，未经他人同意不得擅自使用或修改其肖像。',
          },
          {
            itemType: 1,
            text:
              '第八条 用户应尊重他人著作权。发布他人原创内容需注明出处或带有明显转载标识。不得转载标有“未经授权不得转载”字样的作品，相关责任由转载用户自负。',
          },
          {
            itemType: 1,
            text:
              '第九条 用户发表作品代表作者本人的观点，不代表本平台的观点和看法，与本平台立场无关，相关责任作者自负。',
          },
          {
            itemType: 1,
            text: '第十条 本细则解释权归本平台所有。',
          },
        ]"
        @close="dialogVisible = false"
      />
    </el-dialog>
  </div>
</template>
<script>
import pcwButton from '@/components/common/button.vue'
import pcwTextPanel from '@/components/common/pcwTextPanel.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    pcwButton,
    pcwTextPanel,
  },
  data() {
    return {
      accept: 'video/mp4,video/quicktime,.mkv',
      dialogVisible: false,
    }
  },
  methods: {
    onAddVideoClick() {
      this.$refs.input.value = null
      this.$refs.input.click()
    },
    onFilesChange(e) {
      const { files } = e.target

      if (files) {
        const file = files[0]
        if (file.size > 1 * 1024 * 1024 * 1024) {
          this.$message.error(`视频大小不正确！只支持上传不超过1GB的视频`)
        } else if (file.type !== 'video/mp4' && file.type !== 'video/quicktime' && !file.name.endsWith('.mkv')) {
          this.$message.error('视频格式不正确！只支持上传MP4/MKV/MOV格式的视频文件')
        } else {
          this.setPostFiles({ files })
          this.$router.push('/video-post/publish')
        }
      }
    },
    ...mapActions('video-post', ['setPostFiles']),
  },
  mounted() {
    window.onbeforeunload = () => {}
    if (navigator.userAgent.indexOf('Chrome') === -1) {
      this.$alert(
        '您现在所使用的浏览器不是Chrome浏览器，有些操作可能无法实现您所期望的结果。推荐使用Chrome浏览器继续操作哦~',
      )
    }
  },
}
</script>
<style lang="less">
.video-post-index-container {
  .icon-index {
    display: block;
    width: 280px;
    height: 300px;
    background: transparent url('~~@/assets/videoPost/video-publish.png') center center no-repeat;
    background-size: contain;
    margin: 180px auto 0;
  }
  .button-group {
    .pcw-button + .pcw-button {
      margin-left: 50px;
    }
  }
  .index-text-container {
    margin-top: 40px;
    .index-text {
      margin-top: 22px;
      font-size: 18px;
      line-height: 25px;
      color: #000;
    }
    .index-sub-text {
      margin-top: 12px;
      font-size: 14px;
      line-height: 20px;
      color: #9b9b9b;
    }
    .link {
      color: #1cdd74;
      cursor: pointer;
    }
  }
  .pcw-text-panel-dialog {
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
